import { PlayerInfo } from '@components/helpers/PlayerInfo';
import { Settings } from '@components/hub/player/Settings';
import { IconSettings } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { Modal } from '@components/ui/Modal';
import { useAppStore } from '@stores';
import * as Shared from '@shared/lib';
import { useState } from 'react';

export function Player() {
  const [showSettings, setShowSettings] = useState(false);
  const [showInfo, setShowInfo] = useState(false);

  const { t } = useTranslation(undefined, { keyPrefix: 'Hub.PlayerInfo' });
  const { userData } = useAppStore();

  const weaponXp = userData.weapons.reduce((a, b) => {
    const prestigeBase = b.prestige * Shared.WeaponLevelCalculator.getXpForLevel(30);
    return a + prestigeBase + b.xp;
  }, 0);
  const chassisXp = userData.chassis.reduce((a, b) => {
    const prestigeBase = b.prestige * Shared.ChassisLevelCalculator.getXpForLevel(30);
    return a + prestigeBase + b.xp;
  }, 0);
  const xp = weaponXp + chassisXp;

  const level = Shared.PlayerLevelCalculator.calc(xp);
  const progress = Math.min(100, (xp - level.base) / level.toNext * 100);

  return (
    <>
      <Modal onRequestClose={() => setShowInfo(false)} title={t('playerInfoModal')} isOpen={showInfo}>
        <PlayerInfo playerId={userData.id} />
      </Modal>

      <Modal onRequestClose={() => setShowSettings(false)} title={t('settingsModal')} isOpen={showSettings}>
        <Settings close={() => setShowSettings(false)} />
      </Modal>

      <div className="flex">
        <button className="bg-tertiary border-b border-secondary p-2 flex flex-1" onClick={() => setShowInfo(true)}>
          <img src={`/img/avatars/${userData.avatar}.avif`} className="w-10 h-10" />
          <div className="flex flex-col ml-2 w-full">
            <p className="text-left">{userData.username}</p>
            <div className="w-full h-4 relative bg-secondary flex items-center p-0.5">
              <div className="bg-primary/40 h-full absolute inset-0" style={{ width: `${progress}%` }} />
              <p className="z-10 text-xs text-center w-full">
                {t('level')} {level.current}
              </p>
            </div>
          </div>
        </button>

        <button className="bg-tertiary border-b border-l border-secondary flex items-center justify-center p-2" onClick={() => setShowSettings(true)}>
          <IconSettings className="text-gray-400" size={30} />
        </button>
      </div>
    </>
  );
}